<template>
  <!-- 域名管理 -->
  <div class="container">
    <div>
      <Form
        @submit.native.prevent
        :model="formData"
        label-position="left"
        class="mytable-titleBox clearfix"
      >
        <RadioGroup
          v-model.trim="formData.author_id"
          type="button"
          class="fl mr20"
          @on-change="handleRefundchange"
        >
          <Radio :label="v.id" v-for="(v, i) in authorData" :key="i">{{
            v.author
          }}</Radio>
        </RadioGroup>
        <div class="fr addAuthor">
          <Button type="primary" @click="add" class="ml32">新增</Button>
        </div>
      </Form>
    </div>
    <Table
      :loading="tableLoading"
      class="mt24"
      :columns="columns"
      :data="tableData"
    ></Table>
    <Modal
      v-model="modalVisibile"
      width="424"
      :mask-closable="false"
      :title="modalTitle"
      @on-cancel="handleCancel"
    >
      <Form
        @submit.native.prevent
        ref="modalForm"
        :model="modalForm"
        label-position="top"
      >
        <div class="clearfix">
          <FormItem label="商户" class="fl">
            <Select
              ref="select"
              v-model="modalForm.wx_merchant_id"
              style="margin-top: 7px"
              class="input294Width"
            >
              <Option
                v-for="(option, index) in merchantData"
                :value="option.wx_merchant_id"
                :key="index"
                >{{ option.merchant_name }}</Option
              >
            </Select>
          </FormItem>
        </div>
      </Form>
      <div slot="footer">
        <Button type="text" @click="handleCancel">取消</Button>
        <Button
          :loading="modalLoading"
          type="primary"
          @click="handleModalSubmit"
          >确定</Button
        >
      </div>
    </Modal>
    <!-- <Page
      class="mt24"
      :total="total"
      :current="page_num"
      show-elevator
      show-sizer
      show-total
      @on-page-size-change="handleSizeChange"
      @on-change="handlePageChange"
    /> -->
  </div>
</template>

<script>
import { getCookie } from "../../libs/util";
import mixins from "@/mixins/page";
import * as qiniu from "qiniu-js";
import authorOrder from "@/components/authorOrder";
import { setInterval } from "timers";
export default {
  mixins: [mixins],
  name: "authorManage",
  components: {
    authorOrder,
  },
  data() {
    return {
      merchantData: [],
      authorData: [],
      authorJson: "",
      modalVisibile: false,
      modalTitle: "新增商户",
      modalForm: {},
      page_num: 1,
      options: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        },
      },

      formData: {
      },
      formData1: {
      },
      tableLoading: false,
      tableData: [],
      modalLoading: false,
      columns: [
        {
          title: "ID",
          key: "wx_merchant_id",
          width: 180,
          align: "center",
        },
        {
          title: "名称",
          key: "merchant_name",
          align: "center",
        },
        {
          title: "操作",
          align: "center",
          width: 170,
          render: (h, params) => {
            // var status = 0;
            //未使用
            return h("div", [
              h(
                "span",
                {
                  class: {
                    btn_edit: true,
                  },
                  on: {
                    click: () => this.handleDel(params.row),
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
    };
  },
  mounted() {
    this.getAuthorList();
    this.getMerchartList();
  },
  methods: {
    handleDel(params) {
      this.$Modal.confirm({
        render: (h) => {
          return h("div", [
            h(
              "div",
              {
                class: {
                  modal_icon_del: true,
                },
              },
              "删除"
            ),
            h(
              "div",
              {
                class: {
                  modal_text: true,
                },
              },
              "确定要删除吗？"
            ),
          ]);
        },
        onOk: () => {
          this.$api
            .domianDataDel({
              wx_merchant_id: params.wx_merchant_id,
              author_id: this.formData.author_id,
            })
            .then((res) => {
              if (res.code == 0) {
                this.$Message.success("删除成功");
                this.getTableData();
              } else {
                this.$Message.error({
                  content: res.msg,
                  duration: 10,
                });
              }
            });
        },
      });
    },
    getAuthorList() {
      this.$api.domainAuthorList({}).then((res) => {
        if (res.code == 0) {
          this.authorData = res.data;
          this.formData.author_id = res.data[0].id;
          this.getTableData();
        }
      });
    },
    getMerchartList() {
      this.$api.listMerchant({}).then((res) => {
        if (res.code == 0) {
          this.merchantData = res.data;
         
        }
      });
    },
    add() {
      this.modalVisibile = true;
    },
    handleModalSubmit() {
      this.modalLoading = true;
      this.$api
        .merchantAdd({ ...this.modalForm,...this.formData })
        .then((res) => {
          if (res.code == 0) {
            this.$Message.success("添加成功");
            this.modalLoading = false;
            this.getTableData();
            this.handleCancel();
          } else {
            this.$Message.error({
              content: res.msg,
              duration: 10,
            });
            this.modalLoading = false;
          }
        })
        .catch((_) => {
          this.modalLoading = false;
        });
    },
    handleEdit(status, author, params) {
      //status 1使用  2作废
      var title = "";
      var cont = "";
      if (status == 2) {
        title = "作废域名";
        cont = "您确定要将该域名(" + params.domain + ")作废吗?";
      } else {
        title = "使用域名";
        cont = "您确定要使用该域名(" + params.domain + ")吗?";
      }
      this.$Modal.confirm({
        render: (h) => {
          return h("div", [
            h(
              "div",
              {
                class: {
                  modal_icon_del: true,
                },
              },
              title
            ),
            h(
              "div",
              {
                class: {
                  modal_text: true,
                },
              },
              cont
            ),
          ]);
        },
        onOk: () => {
          this.$api
            .domianUse({ id: params.id, status: status, author: author })
            .then((res) => {
              if (res.code == 0) {
                this.$Message.success("操作成功");
                this.getTableData();
              } else {
                this.$Message.error({
                  content: res.msg,
                  duration: 10,
                });
              }
            });
        },
      });
    },
    handleRefundchange() {
      this.page_num = 1;
      this.getTableData();
    },

    // 获取表格数据
    getTableData() {
      this.tableLoading = true;
      let param = {
        author_id: this.formData.author_id,
        // page_num: this.page_num,
        // page_size: this.page_size,
      };
      this.$api.domianDataList(param).then((res) => {
        if (res.code === 0) {
          this.tableData = res.data;
          // this.total = res.data;
          this.tableLoading = false;
        } else {
          this.$Message.error(res.msg);
        }
      });
    },
    // 弹框取消
    handleCancel() {
      this.$refs.modalForm.resetFields();
      this.modalForm = Object.assign({}, this.modalForm1);
      this.modalVisibile = false;
      this.date = [];
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .ivu-form-item {
  margin-bottom: 0;
}

.checkReset:first-child {
  margin-right: 8px;
}

.ivu-modal-footer {
  border-top: none !important;
}

.shadowLine {
  width: 660px;
  height: 1px;
  background: #e9e9e9;
  margin: 24px 0;
}

.wechartBox {
  width: 282px;
  border: 1px solid #dce1e6;
  border-radius: 4px;
  line-height: 32px;
  padding-left: 12px;

  span {
    width: 74px;
    text-align: center;
    border-left: 1px solid #dce1e6;
    cursor: pointer;
  }
}

/deep/ .ivu-upload-drag {
  border: none;
  background: transparent;
}

/deep/ .textarea.ivu-input {
  min-height: 88px;
  height: 88px;
}

.playFont {
  color: #8a9299;
}

.boldTitle {
  color: #000;
  font-weight: bold;
  font-size: 14px;
}

.graybg {
  width: 724px;
  height: 12px;
  background: #f0f3f5;
  position: relative;
  left: -32px;
  margin-bottom: 24px;
  margin-top: 8px;
}

.shadowTitleClick span {
  cursor: pointer;
}

/deep/ .table_pic {
  width: 40px;
  height: 40px;
  border-radius: 100%;
  display: block;
  cursor: pointer;
}
</style>
